import { BdsGrid, BdsIllustration, BdsTypo } from 'blip-ds/dist/blip-ds-react/components';
import React from 'react';
import './styles.scss';

type EmptyStateProps = {
    isSearch: boolean;
    messageWhenSearching?: string;
    messageWhenNoItems?: string;
};

export const TableRowEmptyState: React.FC<EmptyStateProps> = props => {
    return (
        <div className="empty-state-row">
            <BdsGrid
                style={{ width: '100%' }}
                direction="column"
                justify-content="center"
                align-items="center"
                padding="4"
            >
                <BdsGrid gap="4" style={{ width: '100%' }} align-items="center" justify-items="space-around">
                    <div style={{ height: '100px' }}>
                        <BdsIllustration
                            type="blip-outline"
                            name={props.isSearch ? 'search' : 'friendly'}
                        ></BdsIllustration>
                    </div>
                    <BdsTypo bold="semi-bold">
                        {props.isSearch ? props.messageWhenSearching : props.messageWhenNoItems}
                    </BdsTypo>
                </BdsGrid>
            </BdsGrid>
        </div>
    );
};
